import { useQuery } from '@tanstack/react-query'

import { getCanRequestSendingCard } from '@src/api'
import { DefaultApiGetCanRequestSendingCardRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchCanRequestSendingCard = (
  params: DefaultApiGetCanRequestSendingCardRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getCanRequestSendingCard(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_CAN_REQUEST_SENDING_CARD,
      params.organizationId,
    ],
  })
}
